import flow from 'lodash/flow';
import { withAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
var outerLevel = [];
var innerLevel = [withAllhomesApi('inspections', 'isInInspectionPlan')];
var pageWrapper = function pageWrapper() {
  for (var _len = arguments.length, additional = new Array(_len), _key = 0; _key < _len; _key++) {
    additional[_key] = arguments[_key];
  }
  return flow(...additional, ...innerLevel, ...outerLevel);
};
export default pageWrapper;